import { render } from "./Insurances.vue?vue&type=template&id=0d52c6e8&scoped=true&lang=pug"
import script from "./Insurances.vue?vue&type=script&lang=js"
export * from "./Insurances.vue?vue&type=script&lang=js"

import "./Insurances.vue?vue&type=style&index=0&id=0d52c6e8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d52c6e8"]])

export default __exports__